import { css, ThemedCssFunction } from 'styled-components'
import { BREAKPOINTS } from './constants'

export const getBreakpoint = (index: number): ThemedCssFunction<any> => (
  templateStringArray: any,
  ...interpolations: any[]
) => {
  return css`
		@media ${css`only screen and (min-width: ${BREAKPOINTS[index]}px`}) {
			${css(templateStringArray, ...interpolations)}
		}
	`
}



// WEBPACK FOOTER //
// ./src/styles/getBreakpoint.ts